export const buttonComputed = {
  computed: {
    buttonElStyles() {
      const { corners, fillStyle, backgroundColor, textColor } = this.button;

      // fill styles
      let bgColorBorderColor = {};
      if (fillStyle.value === "fill") {
        bgColorBorderColor.backgroundColor = backgroundColor.value;
        bgColorBorderColor.border = `2px solid transparent`;
      } else if (fillStyle.value === "border") {
        bgColorBorderColor.border = `2px solid ${backgroundColor.value}`;
        bgColorBorderColor.backgroundColor = "transparent";
      }

      // direct styles
      const styles = {
        borderRadius:
          corners.value === "round" ? "var(--button-border-radius)" : 0,
        color: textColor.value,
        ...bgColorBorderColor,
      };
      // return
      return styles;
    },
  },
};
